import { getRailsClient, getRailsFormClient } from "sj-ui-toolkit/src/client";
import { setAdminSettings, setAdminInfos } from "sj-ui-toolkit/src/api/admin/settings";
import { getSiteSettings } from "sj-ui-toolkit/src/api/siteSettings";
import type { SiteSettings } from "sj-ui-toolkit/src/api/types/siteSettingTypes";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface AdminSettings {
  numberOfTries?: string;
}

export interface LogoUploadResponse {
  smallLogoUrl?: string;
  thumbLogoUrl?: string;
}

export interface LevelData {
  id: number;
  name: string;
  description: string;
  rankName: string;
  variant?: string;
  mapId?: number;
}

export interface LevelsListData {
  belt?: LevelData[];
  climb?: LevelData[];
  level?: LevelData[];
}

export interface LevelUpdatePayload {
  id: number;
  name: string;
  description: string;
  variant: string;
  mapId: number;
}

// ---------------------------------------------------------------------------
// Admin settings
// ---------------------------------------------------------------------------

export const updateAdminSetting = async (
  name: string,
  value: string | boolean | number,
  postURL?: string
): Promise<unknown> => {
  // "" tells setAdminSettings to hit /disable; truthy hits /activate
  const normalizedValue = value === false ? "" : String(value);
  const response = await setAdminSettings({ name, value: normalizedValue }, postURL);
  return response;
};

export const updateAdminInfo = async (info: Record<string, string>): Promise<unknown> => {
  const response = await setAdminInfos(info);
  return response;
};

// ---------------------------------------------------------------------------
// Site settings
// ---------------------------------------------------------------------------

export const fetchSiteSettings = async (): Promise<SiteSettings | null> => {
  const response = await getSiteSettings();
  return response?.site ?? null;
};

// ---------------------------------------------------------------------------
// Logo upload
// ---------------------------------------------------------------------------

export const uploadLogoImage = async (file: File): Promise<LogoUploadResponse> => {
  const API = "/api/internal_api/v1/admin/infos/upload_logo_image";
  const formData = new FormData();
  formData.append("logo_image", file);

  const client = getRailsFormClient();
  const { data } = await client.post(API, formData);

  return {
    smallLogoUrl: data?.smallLogoUrl,
    thumbLogoUrl: data?.thumbLogoUrl,
  };
};

export const clearLogoImage = async (): Promise<unknown> => {
  const API = "/api/internal_api/v1/admin/infos/set_default_logo";
  const { data } = await getRailsClient().put(API);
  return data;
};
